import { useEffect } from 'react';

import type { ReviewTemplate } from '@/types/review/ReviewTemplate';

interface UseAssignTemplateProps {
    reviewTemplateId?: string;
    templates: ReviewTemplate[];
    setSelectedTemplate: (template: ReviewTemplate) => void;
}

export const useAssignTemplate = ({
    reviewTemplateId,
    templates,
    setSelectedTemplate,
}: UseAssignTemplateProps) => {
    useEffect(() => {
        if (reviewTemplateId) {
            const template = templates.find((template) => template.id === reviewTemplateId);

            if (template) {
                setSelectedTemplate(template);
            }
        }
    }, [reviewTemplateId, templates, setSelectedTemplate]);
};
